import { gql } from '@apollo/client'
import React from 'react'

import { sessionsClient } from '../../../../utils/apollo/api'
import { useModalData } from '../../../../components/modals/ModalsContext'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const usePublicTokenState = () => React.useContext(Context)
export const usePublicToken = () => usePublicTokenState()?.publicToken

const QUERY = gql`
  query PublicToken($id: ID) {
    publicToken(id: $id, filter: { includeDisabled: true }) {
      id
      name
      token
      type
      action
      amountLeft
      expireDate
      conditions
      payload
    }
  }
`

const PublicTokenLoader = ({ children }) => {
  const id = useModalData()

  const { data, ...state } = useQuery(QUERY, {
    variables: { id },
    client: sessionsClient
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default PublicTokenLoader
